import React, { createContext, useState } from 'react';
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { IFormGridProps } from 'library/types/IFormGridProps'
import { SystemGrid, SystemPanel, HttpService } from 'library'
import ProjectScoreCardDetail from 'Components/Opportunities/ProjectScoreCardDetail';

export const scoreContext = createContext(null);

const CommentsItems = (props: IFormGridProps) => {
    const [counter, setCount] = useState(1500);
    const [totalScore, setTotalScore] = useState(0)
    const [totalTens, setTotalTens] = useState(0)
    const [totalZero, setTotalZero] = useState(0)
    const [totalLessThen4, setTotalLessThen4] = useState(0)
    const [data, setData] = useState([]);
    const [scoreCardGroupId, setscoreCardGroupId] = useState(0);
    const OpportunityId = props.data.OpportunityId;

    const ScoreCardGroupUrl = "/ScoreCardVersionGroup/CurrentScoreVersionGroup/" + OpportunityId;

    const OnSaveClick = () => {
        var urllocation = '/ScoreCardAnswers/AddOrUpdateAnswer';
        HttpService.post(urllocation, data);

        var url = '/ScoreCardAnswers/AddOrUpdateGroupResult';
        HttpService.post(url, { OpportunityId: OpportunityId, ScoreCardGroupId: scoreCardGroupId, TotalScore: totalScore, TotalPositive: totalTens, TotalZero: totalZero, TotalNegative: totalLessThen4 });

        setTimeout(() => {
            setCount(counter + 1);
        }, 500)
    }

    return (
        <scoreContext.Provider value={{ setTotalScore, setTotalTens, setTotalZero, setTotalLessThen4, OpportunityId, setData, setscoreCardGroupId }}>
            <SystemPanel label="Project Score Card" securityObject="Top.ScoreCardGroups" showAdd={false} refresh={props.refresh}>
                <div className="col-md-12 d-flex justify-content-end">
                    <button className="btn btn-primary" onClick={OnSaveClick}> <i className="icon-save1"></i> Save </button>
                </div>
                <SystemGrid onRowClick={props.onRowClick} pageable={true} dataSource={ScoreCardGroupUrl} refresh={props.refresh + counter}>
                    <Column key={1} field="SubName" title="Evaluation" width="auto" />
                    <Column key={2} title="Total Score" width="auto" columnMenu={null} cell={(item) => {
                        return (<><td> < input type="text" id={"totalScore" + item.dataItem.ScoreCardGroupId} name={"totalScore" + item.dataItem.ScoreCardGroupId} disabled value={item.dataItem.TotalScore ? item.dataItem.TotalScore : 0} /></td></>)
                    }} />
                    <Column key={3} title="Total # of 10" width="auto" columnMenu={null} cell={(item) => {
                        return (<><td> < input type="text" id={"totalTens" + item.dataItem.ScoreCardGroupId} name={"totalTens" + item.dataItem.ScoreCardGroupId} disabled value={item.dataItem.TotalPositive ? item.dataItem.TotalPositive : 0} /> </td></>)
                    }} />
                    <Column key={4} title="Total # of 0" width="auto" columnMenu={null} cell={(item) => {
                        return (<><td> < input type="text" id={"totalZero" + item.dataItem.ScoreCardGroupId} name={"totalZero" + item.dataItem.ScoreCardGroupId} disabled value={item.dataItem.TotalZero ? item.dataItem.TotalZero : 0} /> </td></>)
                    }} />
                    <Column key={5} title="Total # of Negative (< 4)" width="auto" columnMenu={null} cell={(item) => {
                        return (<><td> < input type="text" id={"totalLessThen4" + item.dataItem.ScoreCardGroupId} name={"totalLessThen4" + item.dataItem.ScoreCardGroupId} disabled value={item.dataItem.TotalNegative ? item.dataItem.TotalNegative : 0} /> </td></>)
                    }} />
                </SystemGrid>

                <SystemGrid
                    onRowClick={props.onRowClick}
                    pageable={false}
                    dataSource={ScoreCardGroupUrl}
                    refresh={props.refresh + counter}
                    detail={ProjectScoreCardDetail}
                    expandField="expanded" >
                    <Column key={1} field="Name" title="Name" width="auto" />
                </SystemGrid>
            </SystemPanel>
        </scoreContext.Provider>)
}

export default CommentsItems